export const addFormAction = function (form) {
    return {
        type: "ADD_FORM",
        payload: form
    }
};

/*
 *
 * Sections
 *
 */
export const addSectionAction = function (data) {
    return {
        type: "ADD_SECTION",
        payload: data
    }
};

export const updateSectionAction = function (data, remove = false) {
    return {
        type: "UPDATE_SECTION",
        payload: data,
        remove: remove
    }
};


/*
 *
 * Groups
 *
 */
export const addGroupAction = function (data, section) {
    return {
        type: "ADD_GROUP",
        payload: data,
        section: section
    }
};

export const updateGroupAction = function (data, section, remove = false) {
    return {
        type: "UPDATE_GROUP",
        payload: data,
        section: section,
        remove: remove
    }
};


/*
 *
 * Questions
 *
 */
export const addQuestionAction = function (data, section, group) {
    return {
        type: "ADD_QUESTION",
        payload: data,
        section: section,
        group: group,
    }
};

export const updateQuestionAction = function (data, section, group, remove = false) {
    return {
        type: "UPDATE_QUESTION",
        payload: data,
        section: section,
        group: group,
        remove: remove
    }
};

export const reorderQuestions = function (newOrder, section, group) {
    return {
        type: "REORDER_QUESTIONS",
        payload: newOrder,
        section: section,
        group: group
    }
}

/*
 *
 * Answers
 *
 */
export const addAnswerAction = function (data, section, group, question) {
    return {
        type: "ADD_ANSWER",
        payload: data,
        section: section,
        group: group,
        question: question
    }
};

export const updateAnswerAction = function (data, section, group, question, remove = false) {
    return {
        type: "UPDATE_ANSWER",
        payload: data,
        section: section,
        group: group,
        question: question,
        remove: remove
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form.js